/**
 * Adds a value to the current value.
 *
 * @param {number|string} x - Current value.
 * @param {number|string} y - Value to be added.
 * @returns {number}
 */
export function add(x, y) {
  return Number(x) + Number(y);
}
